import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import type { Service } from '../types/business';
import { servicos } from '../data/business';
interface ServicesSectionProps {
  onSelecionar: (servico: Service) => void;
}
export function ServicesSection({
  onSelecionar
}: ServicesSectionProps) {
  return <section className="px-4 pt-12" aria-labelledby="titulo-servicos" data-id="element-130" data-mp="26k0dumvyce39">
      <SectionHeading id="titulo-servicos" overline="Especialidades" titulo="Como eu trato" descricao="Toque para ver resultados reais, duração e agendar sua avaliação no WhatsApp." data-id="element-131" data-mp="26ip8iimuyya1" />

      <ul className="grid grid-cols-2 gap-3" data-id="element-132" data-mp="22if4hbimmhxt">
        {servicos.map(servico => <li key={servico.id} className="flex" data-id="element-133" data-mp="1nlo0eoy0ci1v">
            <motion.button type="button" onClick={() => onSelecionar(servico)} whileTap={{
          scale: 0.985
        }} transition={{
          duration: 0.12,
          ease: [0.23, 1, 0.32, 1]
        }} className="group flex w-full flex-col overflow-hidden rounded-2xl border border-shell bg-white/60 text-left transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-134" data-mp="1nmz8v22eedzb">
              <img src={servico.imagem} alt="" className="h-32 w-full object-cover" data-id="element-135" data-mp="26wjtggpk1fcx" />
              <span className="flex flex-1 flex-col p-3.5" data-id="element-136" data-mp="21xp2grhfokhq">
                <span className="block text-[14px] font-medium leading-snug text-ink" data-id="element-137" data-mp="21z9y6kfhi9h6">
                  {servico.nome}
                </span>
                <span className="mt-1 block text-[12px] leading-snug text-muted" data-id="element-138" data-mp="2ayer9b8a1aly">
                  {servico.resumo}
                </span>
                <span className="mt-auto flex items-center gap-1.5 pt-3 text-[11.5px] font-medium text-mocha" data-id="element-139" data-mp="1n7ras1kapcns">
                  Ver resultados
                  <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={1.8} data-id="element-140" data-mp="1j5edm1jm6n2m" />
                </span>
              </span>
            </motion.button>
          </li>)}
      </ul>
    </section>;
}